var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import { ClaimTypeTrigram } from '@shared/types/api/claim';
const qualification = namespace('qualification');
const counting = namespace('counting');
let NoFollowupIndex = class NoFollowupIndex extends Vue {
    constructor() {
        super(...arguments);
        this.defaultIllustration = require('@declaration/assets/images/documents/checklist.svg');
        this.robberyNoDamagesIllustration = require('@declaration/assets/images/documents/refus.svg');
        this.ddeNoFollowupIllustration = require('@declaration/assets/images/documents/refus-total.svg');
    }
    close() {
        quitClaimDeclarationCloseCallback(this);
    }
    get noFollowUpCause() {
        if (this.typeTrigram === ClaimTypeTrigram.Robbery) {
            return 'robberyNoDamages';
        }
        else if (this.typeTrigram === ClaimTypeTrigram.WaterDamage) {
            return 'ddeNoFollowup';
        }
        else
            return 'vacationRentalNotCovered';
    }
    get contents() {
        let contents;
        switch (this.noFollowUpCause) {
            case 'robberyNoDamages':
                contents = {
                    title: 'error.claim.robbery.noDamages.no-followup.title',
                    illustration: this.robberyNoDamagesIllustration,
                    description: 'error.claim.robbery.noDamages.no-followup.description',
                };
                break;
            case 'ddeNoFollowup':
                contents = {
                    title: this.DDENoFollowupCauseTitle,
                    illustration: this.ddeNoFollowupIllustration,
                    description: this.DDENoFollowupCauseDescription,
                };
                break;
            default:
                contents = {
                    title: 'error.claim.no-followup',
                    illustration: this.defaultIllustration,
                    description: 'error.claim.no-followup.garanties.location.description',
                };
        }
        return contents;
    }
    get DDENoFollowupCauseDescription() {
        if (!this.counting.hasDamages &&
            this.qualification.isResponsibleForDamagesToOthers &&
            !this.qualification.hasPlumberIntervened) {
            return 'claim.declaration.exit.dde.no-followup.has_no_damages.no_leakage_cause_searched.description';
        }
        else if (!this.counting.hasDamages && !this.qualification.isResponsibleForDamagesToOthers) {
            return 'claim.declaration.exit.dde.no-followup.has_no_damages.not_responsible.description';
        }
        return 'claim.declaration.exit.dde.no-followup.description';
    }
    get DDENoFollowupCauseTitle() {
        if (!this.counting.hasDamages && !this.qualification.isResponsibleForDamagesToOthers) {
            return 'claim.declaration.exit.dde.no-followup.has_no_damages.not_responsible.title';
        }
        return 'claim.declaration.exit.dde.no-followup.title';
    }
};
__decorate([
    qualification.State('typeTrigram')
], NoFollowupIndex.prototype, "typeTrigram", void 0);
__decorate([
    qualification.State('qualification')
], NoFollowupIndex.prototype, "qualification", void 0);
__decorate([
    counting.State('counting')
], NoFollowupIndex.prototype, "counting", void 0);
NoFollowupIndex = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
            goBack: null,
        },
    })
], NoFollowupIndex);
export default NoFollowupIndex;
